import { Component } from '@angular/core';
import { FirearmAssignmentService } from 'assets-service';
import { Observable } from 'rxjs';
import { BaseEmailTemplatesComponent, TemplateParameters } from '../../base-email-templates-landing-page.component';


@Component({
  selector: 'firearm-assignment-storage-dispose-police-notify-email-templates',
  templateUrl: './firearm-assignment-storage-dispose-police-notify-email-template.component.html',
  styleUrls: ['./firearm-assignment-storage-dispose-police-notify-email-template.component.scss']
})
export class FirearmAssignmentStorageDisposePoliceNotifyEmailTemplatesComponent extends BaseEmailTemplatesComponent {

  constructor(private firearmAssignmentService: FirearmAssignmentService) {
    super();
  }

  protected getExampleTemplateParameters(backgroundServiceCall?: boolean): Observable<TemplateParameters> {
    return this.firearmAssignmentService.exampleNotifyPoliceTemplateParameters(false, backgroundServiceCall);
  }


}
